import { languagesList, roles } from "../../../utils/constants";
import { userHasLevel } from "../../../engine/AuthRoute";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import { RiMenuSearchLine } from "react-icons/ri";
import { setPagination } from "../Slices/Billing.slice";
import React from "react";
import { BiSearch } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import moment from "moment";

export const BillsByTypeInputs = ({
  type,
  monthsSelectContent,
  yearsSelectContent,
  loading,
  initSearch,
  initialValuesForm,
  dispatchActionGetBills,
  setSearch,
  formRef,
}) => {
  const { institutionsFilter, languagesFilter } = useSelector(
    state => state.billing,
  );

  const dispatch = useDispatch();

  const inputs = [
    {
      parentLabel: null,
      children: [
        {
          label: "Mois",
          dataIndex: "month",
          key: "month",
          name: "month",
          type: "select",
          col: 4,
          allowClear: false,
          selectContent: monthsSelectContent,
        },
        {
          label: "Année",
          dataIndex: "year",
          key: "year",
          name: "year",
          value: yearsSelectContent[0].value,
          type: "select",
          col: 4,
          allowClear: false,
          selectContent: yearsSelectContent,
        },
        {
          label: "Langues",
          dataIndex: "langues",
          key: "langues",
          name: "langues",
          type: "select",
          col: 4,
          allowClear: true,
          selectContent: languagesFilter[type]
            .filter(e => e !== "" && e !== null)
            .map(o => {
              let label = languagesList.find(e => e.value === o).label;
              return { label: label, value: o };
            }),
        },
        {
          label: "Numéro interne",
          name: "bill_number",
          value: "",
          type: "input",
          capitalize: false,
          col: 6,
        },
        {
          label: "Numéro de référence",
          name: "reference",
          value: "",
          type: "input",
          capitalize: false,
          col: 6,
        },
        {
          label: "Numéro de prestation",
          name: "prestation_reference",
          value: "",
          type: "input",
          capitalize: false,
          col: 6,
        },

        // {
        //   visible: userHasLevel({
        //     not: {
        //       [roles.institution]: "r", //
        //     },
        //   }),
        //   label: "Filtre par institution",
        //   name: "institution",
        //   placeholder: "Filtre par institution",
        //   allowClear: true,
        //   showSearch: true,
        //   value: [],
        //   required: false,
        //   endPoint: "institutions",
        //   type: "dynamic-select",
        //   capitalize: false,
        //   col: 6,
        //   itemsCallBack: (institutions, form) => {},
        //   itemCallback: item => {
        //     return {
        //       key: item._id,
        //       label: `${item.name}`,
        //       value: item._id,
        //     };
        //   },
        //   sorter: (a, b) => {
        //     return a.institution.name.localeCompare(b.institution.name);
        //   },
        // },
        {
          visible: userHasLevel({
            not: {
              [roles.institution]: "r", //
            },
          }),
          label: "Filtre par institution",
          name: "institution",
          placeholder: "Filtre par institution",
          allowClear: true,
          showSearch: true,
          value: [],
          render: () => {},
          type: "select",
          selectContent: [...institutionsFilter[type]]
            .map(e => {
              return {
                ...e,
                label: `${e.label} (${e.billCount})`,
              };
            })
            .sort((a, b) => a?.label?.localeCompare(b?.label)),
          capitalize: false,
          xl: 8,
          lg: 8,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          type: "component",
          style: { textAlign: "left" },
          xl: 3,
          lg: 4,
          md: 6,
          sm: 8,
          xs: 12,
          label: "",
          component: () => (
            <>
              <Button
                loading={loading}
                size={"middle"}
                type={"primary"}
                style={{
                  marginTop: "-12px",
                  width: "100%",
                  display: "block",
                  fontWeight: "bold",
                }}
                icon={<BiSearch style={{ marginTop: "0px" }} size={25} />}
                onClick={dispatchActionGetBills}
              >
                Rechercher
              </Button>
            </>
          ),
        },
        {
          type: "component",
          xl: 3,
          lg: 3,
          md: 6,
          sm: 8,
          xs: 12,
          label: "",
          style: { textAlign: "left" },
          component: () => (
            <Button
              style={{
                marginTop: "-7px",
                width: "100%",
                color: colorPrimary,
                fontWeight: "bold",
              }}
              icon={<GrPowerReset style={{ marginTop: "-3px" }} size={15} />}
              onClick={async () => {
                setSearch(initSearch);

                formRef.current.resetFields(); // Reset the form fields using the ref
                formRef.current.setFieldsValue(initialValuesForm);
                await dispatch(
                  setPagination({
                    currentPage: 1,
                    pageSize: 10,
                    sorter: undefined,
                  }),
                );
                await dispatchActionGetBills();
              }}
              size="middle"
              type={"text"}
            >
              Réinitialiser
            </Button>
          ),
        },

        // {
        //   visible: userHasLevel({
        //     not: {
        //       [roles.institution]: "r", //
        //     },
        //   }),
        //   label: "Type de facture",
        //   name: "groupedBilling",
        //   value: "false",
        //   required: true,
        //   type: "select",
        //   selectContent: [
        //     { label: "Individuelle", value: "false" },
        //     { label: "Groupée", value: "true" },
        //   ],
        //   capitalize: false,
        //   col: 6,
        // },
      ],
    },
  ];

  return inputs;
};
